import { useFormatMessage } from '../../../intl/intl'

import {
  storeStatusStatusOpts as SSSOpts,
  storeStatusDropdownTextIds as ssDdTextIds,
} from '../constants'

import type { MultiStoreNotificationItemProps } from '../types'

function useTexts(props: MultiStoreNotificationItemProps) {
  const { state, total = 0 } = props
  const storeName = useFormatMessage({ id: ssDdTextIds.storeName })
  const stateName = useFormatMessage({ id: SSSOpts[state]?.textId ?? 'error' })
  return {
    pluralState: stateName + 's',
    storeName: storeName + (total > 1 ? 's' : ''),
  }
}

export const hooks = {
  useTexts,
}
